import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';

import { SettingsRoutingModule } from './settings-routing.module';
import { CodeImportComponent } from './pages/code-import/code-import.component';

@NgModule({
  imports: [
    CommonModule,
    SettingsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule
  ],
  declarations: [CodeImportComponent],
  exports: [CodeImportComponent]
})
export class SettingsModule { }
